import React from 'react';
import { Award, Users, Target, Zap } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Award,
      title: 'Proven Expertise',
      description: 'Years of experience delivering successful digital marketing campaigns across industries.'
    },
    {
      icon: Users,
      title: 'Dedicated Team',
      description: 'Expert marketers, content creators, and strategists working together for your success.'
    },
    {
      icon: Target,
      title: 'Result-Driven',
      description: 'We focus on measurable outcomes - increased leads, better ROI, and business growth.'
    },
    {
      icon: Zap,
      title: 'Cutting-Edge Tools',
      description: 'Latest digital marketing technologies and platforms to keep you ahead of competition.'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="text-sm font-semibold text-gray-600 uppercase tracking-wide">About HSR Business Promoters</span>
            <h2 className="mt-2 text-4xl lg:text-5xl font-bold text-gray-900 leading-tight" style={{ fontFamily: 'var(--font-serif)' }}>
              Your Trusted Partner in Digital Growth
            </h2>
            <p className="mt-6 text-lg text-gray-600 leading-relaxed">
              Located in the heart of Zirakpur, HSR Business Promoters is a full-service digital marketing agency dedicated to helping professionals and businesses thrive in the digital landscape.
            </p>
            <p className="mt-4 text-lg text-gray-600 leading-relaxed">
              From video production to comprehensive ad campaigns on Meta and Google platforms, we combine creativity with data-driven strategies to deliver exceptional results. Our expertise spans across multiple industries, with specialized knowledge in marketing for healthcare professionals, legal services, immigration consultants, and wedding planners.
            </p>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-2 gap-6 mt-12">
              {features.map((feature, index) => {
                const IconComponent = feature.icon;
                return (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
                        <IconComponent className="w-6 h-6 text-black" />
                      </div>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 mb-1">{feature.title}</h3>
                      <p className="text-sm text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Content - Image Grid */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="rounded-xl overflow-hidden shadow-lg h-48">
                  <img
                    src="https://images.pexels.com/photos/11329815/pexels-photo-11329815.jpeg"
                    alt="Video Production"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="rounded-xl overflow-hidden shadow-lg h-64">
                  <img
                    src="https://images.unsplash.com/photo-1668606143326-4d53db523e00"
                    alt="Podcast Production"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="space-y-4 mt-8">
                <div className="rounded-xl overflow-hidden shadow-lg h-64">
                  <img
                    src="https://images.unsplash.com/photo-1632187989763-c9c620420b4d"
                    alt="Team Work"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="rounded-xl overflow-hidden shadow-lg h-48">
                  <img
                    src="https://images.pexels.com/photos/33231527/pexels-photo-33231527.jpeg"
                    alt="Studio Setup"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Decorative Element */}
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-yellow-300 rounded-full opacity-20 blur-2xl"></div>
            <div className="absolute -top-8 -right-8 w-32 h-32 bg-blue-300 rounded-full opacity-20 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
